import { render, staticRenderFns } from "./select-vue.vue?vue&type=template&id=4057b0dd&"
import script from "./select-vue.vue?vue&type=script&lang=js&"
export * from "./select-vue.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4057b0dd')) {
      api.createRecord('4057b0dd', component.options)
    } else {
      api.reload('4057b0dd', component.options)
    }
    module.hot.accept("./select-vue.vue?vue&type=template&id=4057b0dd&", function () {
      api.rerender('4057b0dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/forms/select/select-vue.vue"
export default component.exports